import { ArrowDown, ArrowUp } from 'lucide-react';

export const fmtNum = (n) => (n ?? 0).toLocaleString('es-ES');
export const fmtPct = (v) => (v == null ? '-' : `${(v * 100).toFixed(1).replace('.', ',')} %`);
export const fmtPos = (v) => (v == null || v === 0 ? '-' : v.toFixed(1).replace('.', ','));
export const fmtFecha = (iso) => {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};
export const urlCorta = (u) => (u || '').replace(/^https?:\/\/(www\.)?duettocatering\.com/, '') || '/';

/**
 * Variación con flecha y color.
 * - tipo "numero": valor = actual - anterior (más es mejor).
 * - tipo "posicion": valor = anterior - actual (positivo = ha subido en Google).
 */
export function Variacion({ valor, tipo = 'numero', nueva = false, decimales = 1 }) {
  if (nueva) {
    return <span className="text-[10px] font-semibold uppercase text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded">Nueva</span>;
  }
  if (valor == null) return <span className="text-xs text-gray-300">-</span>;
  if (valor === 0) return <span className="text-xs text-gray-400">=</span>;
  const bueno = valor > 0;
  const Icono = bueno ? ArrowUp : ArrowDown;
  const texto = tipo === 'posicion'
    ? Math.abs(valor).toFixed(decimales).replace('.', ',')
    : fmtNum(Math.abs(valor));
  return (
    <span className={`inline-flex items-center gap-0.5 text-xs font-medium ${bueno ? 'text-emerald-600' : 'text-red-600'}`}>
      <Icono className="w-3 h-3" />
      {texto}
    </span>
  );
}

export const FILTROS_POSICION = [
  { id: 'todas', label: 'Todas' },
  { id: 'con_clics', label: 'Solo con clics' },
  { id: 'pos_4_10', label: 'Posiciones 4 a 10', hint: 'A un paso de lo más alto de la primera página' },
  { id: 'pos_11_20', label: 'Posiciones 11 a 20', hint: 'Segunda página de Google' },
];

export function aplicarFiltro(filas, filtro) {
  switch (filtro) {
    case 'con_clics':
      return filas.filter((r) => r.clicks > 0);
    case 'pos_4_10':
      return filas.filter((r) => r.position >= 4 && r.position < 11);
    case 'pos_11_20':
      return filas.filter((r) => r.position >= 11 && r.position < 21);
    default:
      return filas;
  }
}

export function ordenar(filas, clave, dir) {
  const signo = dir === 'asc' ? 1 : -1;
  return [...filas].sort((a, b) => {
    const va = a[clave];
    const vb = b[clave];
    if (typeof va === 'string' || typeof vb === 'string') {
      return signo * String(va || '').localeCompare(String(vb || ''), 'es');
    }
    const na = va == null ? (dir === 'asc' ? Infinity : -Infinity) : va;
    const nb = vb == null ? (dir === 'asc' ? Infinity : -Infinity) : vb;
    return signo * (na - nb);
  });
}
